import React from 'react';

const CloseModalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39.598"
    height="39.598"
    viewBox="0 0 39.598 39.598"
    {...props}
  >
    <g id="Group_974" data-name="Group 974" transform="translate(0 19.799) rotate(-45)" >
      <path id="Path_1209" data-name="Path 1209" d="M13.992,0a13.921,13.921,0,0,1,9.9,4.1H23.9a14,14,0,0,1,0,19.792l-.082.082A13.983,13.983,0,0,1,4.1,23.9H4.1A14,14,0,0,1,4.1,4.1l.09-.082A13.951,13.951,0,0,1,13.992,0M12.444,7.242h0v5.2H7.233a1.556,1.556,0,1,0,0,3.113h5.21v5.2a1.552,1.552,0,1,0,3.1,0v-5.2h5.21a1.556,1.556,0,0,0,0-3.113h-5.21v-5.2a1.552,1.552,0,1,0-3.1,0M21.7,6.3h0A10.9,10.9,0,0,0,6.365,6.234L6.3,6.3a10.9,10.9,0,0,0,0,15.4H6.291a10.9,10.9,0,0,0,15.335.066l.066-.066a10.877,10.877,0,0,0,0-15.4Z" transform="translate(0 0)" fill="#ad2f31"/>
    </g>
  </svg>
);

export default CloseModalIcon; 